export { default } from './BlockMarqueeTopic'